jQuery(function($)
{
    var
        $filterContainer = $('#custom-filter-options .filter'),
        $productContainer = $('#content'),
        $productSpecialContainer = $('#content-special'),
        $breadcrumbBacklink = $('.backlink a'),
        $variations = $('#dropdown-variation a');

    /**
	 * append a backlink parameter to specific elements href attribute
	 *
	 * @param jQuery $el
	 * @param string backPath
	 */
    function updateHref($el, backPath)
    {
        $el.each(function()
        {
            var
                $a = $(this),
                href = $a.attr('href'),
                hrefUri = new URI(href);

            hrefUri.setQuery('backlink', backPath);

            $a.attr('href', hrefUri.href());
        });
    }

    /**
	 * append a backlink parameter to area href attributes
	 */
    function updateAreaHref()
    {
        updateHref($('area'), document.location.pathname + document.location.search);
    }

    /**
	 * append a backlink paramter to product list itema href attributes
	 */
    function updateProductsHref()
    {
        if ($filterContainer.length === 0 && $productSpecialContainer.length === 0)
        {
            return;
        }

        updateHref($('.product-list a,.product-tiles a,#content article a',
            $productContainer.add($productSpecialContainer)), document.location.pathname + document.location.search);
    }

    /**
	 * append a backlink parameter to all product variation links href attributes
	 */
    function updateProductVariationHref()
    {
        if (!$breadcrumbBacklink.length || !$variations)
        {
            return;
        }

        let uri = new URI(document.location.href);

        if (!uri.hasQuery('backlink'))
        {
            return;
        }

        let query = URI.parseQuery(uri.search());
        let { backlink } = query;

        updateHref($variations, backlink);
    }

    updateAreaHref();
    updateProductsHref();
    updateProductVariationHref();
    $productContainer.on(orion.constants.EventProductListReloaded, updateProductsHref);
    $('.js-tilesview-item').on(orion.constants.EventTilesviewVariationChanged, updateProductsHref);
});
